import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { euro, fmtWeight } from "@/lib/shop";
import { useCart } from "@/context/CartContext";

export default function CartPage() {
  const { items, update, remove, subtotal, weight } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div data-testid="cart-empty" className="mx-auto max-w-md px-4 py-24 text-center">
        <ShoppingBag className="mx-auto h-10 w-10" />
        <h1 className="mt-4 text-2xl font-extrabold">Il carrello è vuoto</h1>
        <Link to="/" data-testid="cart-go-shop" className="btn-mc mt-6">Vai al catalogo</Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl px-4 pt-6 sm:px-6">
      <h1 className="text-3xl font-extrabold tracking-tight">Carrello</h1>
      <div className="mt-5 space-y-3">
        {items.map((i) => (
          <div key={i.product_id} data-testid={`cart-item-${i.product_id}`} className="card-mc flex items-center gap-3 p-3">
            <Link to={`/prodotto/${i.product_id}`} className="h-20 w-20 shrink-0 overflow-hidden rounded-xl border border-border bg-white">
              {i.image && <img src={imgUrl(i.image)} alt="" className="h-full w-full object-contain" />}
            </Link>
            <div className="min-w-0 flex-1">
              <div className="line-clamp-2 text-sm font-bold">{i.name}</div>
              <div className="text-xs text-muted-foreground">{euro(i.price)} · {fmtWeight(i.weight_g)}</div>
              <div className="mt-2 flex items-center gap-2">
                <div className="flex items-center rounded-full border-2 border-[#0b0b0f] bg-white">
                  <button data-testid={`cart-decrease-${i.product_id}`} className="p-1.5" onClick={() => update(i.product_id, i.quantity - 1)}><Minus className="h-3.5 w-3.5" /></button>
                  <span data-testid={`cart-qty-${i.product_id}`} className="w-7 text-center text-sm font-bold">{i.quantity}</span>
                  <button data-testid={`cart-increase-${i.product_id}`} className="p-1.5" onClick={() => update(i.product_id, i.quantity + 1)}><Plus className="h-3.5 w-3.5" /></button>
                </div>
                <button data-testid={`cart-remove-${i.product_id}`} aria-label="Rimuovi" className="p-2 text-muted-foreground hover:text-red-600" onClick={() => remove(i.product_id)}>
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
            <div className="font-display font-extrabold">{euro(i.price * i.quantity)}</div>
          </div>
        ))}
      </div>
      <div className="card-mc mt-5 p-4">
        <div className="flex justify-between text-sm"><span>Peso totale</span><span data-testid="cart-weight">{fmtWeight(weight)}</span></div>
        <div className="mt-1 flex justify-between font-display text-lg font-extrabold"><span>Subtotale</span><span data-testid="cart-subtotal">{euro(subtotal)}</span></div>
        <p className="mt-1 text-xs text-muted-foreground">La spedizione si sceglie in cassa.</p>
        <button data-testid="cart-checkout-button" className="btn-mc mt-4 w-full !py-3" onClick={() => navigate("/cassa")}>
          Vai alla cassa
        </button>
      </div>
    </div>
  );
}
